import { Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { cn } from "@/lib/cn";

const STEPS = [
  { key: "website", label: "Website" },
  { key: "documents", label: "Documents" },
  { key: "style", label: "Style" },
  { key: "pages", label: "Pages" },
];

export function OnboardingLayout() {
  const { pathname } = useLocation();
  const { signOut } = useAuth();
  const current = STEPS.findIndex((s) => pathname.endsWith(`/${s.key}`));
  return (
    <div className="mx-auto flex min-h-screen w-full max-w-[760px] flex-col px-5 py-10">
      <div className="mb-8 flex items-center justify-between">
        <p className="text-[18px] font-bold tracking-[-0.03em]">Weply</p>
        <button
          type="button"
          className="text-[13px] text-muted"
          onClick={() => void signOut()}
        >
          Sign out
        </button>
      </div>
      <ol className="mb-8 flex gap-2">
        {STEPS.map((s, i) => (
          <li key={s.key} className="flex flex-1 flex-col gap-1.5">
            <div
              className={cn(
                "h-1.5 rounded-full",
                i <= current ? "bg-accent" : "bg-border",
              )}
            />
            <span
              className={cn(
                "text-[12px] font-medium",
                i === current ? "text-ink" : "text-muted",
              )}
            >
              {s.label}
            </span>
          </li>
        ))}
      </ol>
      <Outlet />
    </div>
  );
}

/** `useCompleteStep` invalidates `me`, which makes <Gate> route to the next step. */
export { useCompleteStep } from "./useCompleteStep";
